import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Sizechart from "./pages/Sizechart";
import AdminLayout from "./admin/AdminLayout";
import MainLayout from "./layout/Mainlayout";
import Dashboard from "./admin/Dashboard";
import Category from "./admin/Category";
import Subcategory from "./admin/Subcategory";
import Ordermanagement from "./admin/Ordermanagement";
import Productmanagement from "./admin/Productmanagement";
import AddNewproduct from "./admin/AddNewproduct";
import Blog from "./admin/Blog";
import AdminSizechart from "./admin/Sizechart";
import Usermanagement from "./admin/Usermanagement";
import General from "./admin/General";
import Termscondition from "./pages/Termscondition";
import Privacypolicy from "./pages/Privacypolicy";
import Cancelrefund from "./pages/Cancelrefund";
import AdminLogin from "./admin/AdminLogin";
import ProtectedRoute from "./admin/ProtectedRoute";
import Shipping from "./pages/Shipping";
import Contactus from "./pages/Contactus";
import Sizechartui from "./pages/Sizechart";
import Fag from "./pages/Fag";
import Cart from "./pages/Cart";
import ScrollToTop from "./components/ScrollToTop";
import Mainproduct from "./pages/Mainproducts";
import Productdetail from "./pages/productdetail";
import ComboOffer from "./admin/ComboOfferPage";
import BulkCombo from "./admin/BulkComboPage";
import Wishlist from "./pages/Whishlist";
import Checkout from "./pages/Checkout";
import Shippingoffer from "./admin/Shippingoffer";
import Discount from "./admin/Discount";
import PaymentStatus from "./pages/Paymentstatus";
import Bskuser from "./pages/Bskuser";
import Bsksample from "./admin/Samplecollection"

const App = () => {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="bsk-home" element={<Home />} />
          <Route path="bsk-about" element={<About />} />
          <Route path="bsk-size-chart" element={<Sizechart />} />
          <Route path="bsk-terms-condition" element={<Termscondition />} />
          <Route path="bsk-privacy-policy" element={<Privacypolicy />} />
          <Route path="bsk-cancel-refund" element={<Cancelrefund />} />
          <Route path="bsk-shipping" element={<Shipping />} />
          <Route path="bsk-contact-us" element={<Contactus />} />
          <Route path="bsk-size-chart" element={<Sizechartui />} />
          <Route path="bsk-fag" element={<Fag />} />
          <Route path="bskian-cart" element={<Cart />} />
          <Route path="bsk-wishlist" element={<Wishlist />} />
          <Route path="bsk-main-product" element={<Mainproduct />} />
          <Route path="/:slug" element={<Productdetail />} />
          <Route path="bsk-checkout" element={<Checkout />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/bsk-user" element={<Bskuser />} />
          <Route path="/payment-status" element={<PaymentStatus />} />

        </Route>

        <Route path="/bsk-secure-admin/login" element={<AdminLogin />} />

        <Route
          path="/bsk-secure-admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="category" element={<Category />} />
          <Route path="sub-category" element={<Subcategory />} />
          <Route path="order-management" element={<Ordermanagement />} />
          <Route path="user-management" element={<Usermanagement />} />
          <Route path="product-list" element={<Productmanagement />} />
          <Route path="new-product" element={<AddNewproduct />} />
          <Route path="blog" element={<Blog />} />
          <Route path="off-general" element={<General />} />
          <Route path="size-chart" element={<AdminSizechart />} />
          <Route path="combo-offer" element={<ComboOffer />} />
          <Route path="bulk-offer" element={<BulkCombo />} />
          <Route path="bsk-discount" element={<Discount />} />
          <Route path="bsk-shipping" element={<Shippingoffer />} />
           <Route path="bsk-samcollection" element={<Bsksample />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
